import { render, staticRenderFns } from "./Tin.vue?vue&type=template&id=515ce211&scoped=true&"
import script from "./Tin.vue?vue&type=script&lang=js&"
export * from "./Tin.vue?vue&type=script&lang=js&"
import style0 from "./Tin.vue?vue&type=style&index=0&id=515ce211&scoped=true&lang=css&"
import style1 from "./Tin.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515ce211",
  null
  
)

export default component.exports